<template>
    <div>
        <!-- <div>
            <router-link :to="'/purchase?upgrade='+set_business.business_username" class="btn  sp-button-02 sp-button-sm" style="background-color: #ff3c00;">Upgrade Shop</router-link>
        </div> -->
            <div class="form-card" v-if="!loadx">
                <h3>Add new product</h3>
                <h4><u>{{category.business_category}}</u></h4>
                <div v-if="subscription_offer.products && (subscription_offer.products.service_offer_active == 1)">
                    <form class="sp-form">
                    <h6>Add New <span style="text-transform: capitalize">{{is_product_service}}</span></h6>
                    <div class="form-group">
                        <label>Product Photo </label>
                        <img id="prImagePreview" style="width:100%"/>
                        <div class="sp-form-descr">Maximum Upload Size {{max_upload}}</div>
                        <div class="upload-btn-wrapper" style="cursor:pointer">
                            <button type="button" class="upload-btn">Upload Display <span style="text-transform: capitalize;">{{is_product_service}}</span> Photo</button>
                            <input type="file" id="input-file" @change="onFileChangeNewProduct($event)" accept="image/*"/>
                            <span v-if="file_info[0]"><b>Added {{file_info[0].name}}</b></span>                                                                                                                                                                                                                                                                                                                       
                        </div>
                        <div><span class="sp-form-descr">(You can always add more images or video on this post)</span></div>
                    </div>
                    <div class="form-group"> 
                        <table class="table">
                            <tr>
                                <td>Name</td>
                                <td> <input type="text" v-model="product.product_name" class="form-control" placeholder="Name of Product / Service"/></td>
                            </tr>
                            <tr>
                                <td>Price</td>
                                <td> <input type="number" v-model="product.product_item_price" class="form-control" placeholder=""  required @change="numStrip()">
                                </td>
                            </tr>
                        </table>
                        
                        <h5>Product Details</h5>
                        <table class="table">
                            <tr>
                                <td style="width:25%;"><b>eg:</b> Material: </td>
                                <td style="width:75%;">Pure Leather</td>
                            </tr>
                            <tr v-for="(detail,index) in product_set_details" :key="index">
                                <td style="width:25%;"><input type="text" v-model="product_set_details[index].title" class="form-control"/></td>
                                <td style="width:75%;"> <input type="text" v-model="product_set_details[index].detail" class="form-control"/></td>
                            </tr>
                        </table>

                        <h5>Other details</h5>
                        <table class="table">
                            <tr>
                                <td>Weight(Kg)</td>
                                <td><input type="number" v-model="product.product_item_weight" class="form-control" placeholder="" required></td>
                            </tr>
                            <tr>
                                <td>Quantity<br>in Stock</td>
                                <td><input type="number" v-model="product.product_item_quantity"  class="form-control" placeholder="" required></td>
                            </tr>
                            <tr>
                                <td>Product Adddotional Details</td>
                                <td><input type="number" v-model="product.product_description"  class="form-control" placeholder="" required></td>
                            </tr>
                        </table>
                    
                    </div>
                        <div class="form-group">
                            <p style="color:#1a73da">{{data_processing_message}}<br><br/>
                            <span style="color:#ff0000">{{data_error_message}}</span></p>
                            <div v-if="action_loading" class="loading-sm"></div>
                            <button :disabled="disable_btn" type="button" class="btn sp-button-02 sp-button-sm"  @click="addProduct">ADD <span style="text-transform: uppercase">{{is_product_service}}</span></button>
                            <button type="button" class="btn sp-button-02 sp-button-sm" @click="reset">Cancel</button>
                        </div>
                    </form>
                </div>
                <div v-else>
                    <div v-if="subscription_offer.products">
                        <p style="color:#ff0000;"><b>Sorry you can only add {{subscription_offer.products.service_offer_limit}} product(s) on this plan</b></p>
                        <router-link :to="'/purchase?upgrade='+set_business.business_username" class="btn  sp-button-02 sp-button-sm" style="background-color: #ff3c00;">Upgrade Shop</router-link>
                    </div>
                    <div v-else>
                        <p style="color:#ff0000;"><b>Sorry no subscription details found, you cannot add products at the moment</b></p>
                    </div>
                </div>
            </div>
    </div>
</template>

<script>
// import AccountResources from '../../Template/script.js' //scripts
import AccountResources from '../../Resources/script.js' //scripts
import Purchase from '../../../Purchase'
export default {
    mixins: [AccountResources],
    data () {
        return {
            loadx: true,
            set_user:this.$store.getters['account/getUser'],
            set_business:this.$store.getters['account/getUserBusiness'],
            set_sub_offers:this.$store.getters['account/getSellpointAppSubscriptionOffers'],
        }
    },

    methods: {
        setPage(){
            this.sellpoint = this.set_business;
            //get product offers
            let self = this;
            localforage.getItem('xvue', function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.sellpoint =  value.account.store_sellpoint.store_sellpointData;
                    //
                    let offer_set = value.account.store_sellpoint.store_sellpointAppSubscriptionOffers;
                    console.log(offer_set)
                    self.loadx = false;
                    if(Object.keys(offer_set).length > 0){
                        for(let offer of offer_set){
                            if(offer.service_offer == 5){
                                self.subscription_offer.products = offer;
                            }
                        }
                    }
                    
                }else{}
            });

            
        },
       
    },

    components: {
        'purchase':Purchase,
    },

    created: function(){
        this.setPage();
        this.loadCategory();
    }

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// AddProduct.vue?edf29f22